/**
 * Drop zone for App Builder – accepts component drops from the palette.
 */
import React from 'react';
import { Box } from '@mui/material';
import { useDrop } from 'react-dnd';
import { ITEM_TYPE } from './AppBuilderComponentPalette';

export default function AppBuilderDropZone({ position, label, onDrop, onAdd, children }) {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: ITEM_TYPE,
    drop: (item) => {
      onDrop?.(item.componentType, position);
      return { position };
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  return (
    <Box
      ref={drop}
      sx={{
        flex: '0 0 auto',
        minHeight: 56,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px dashed',
        borderColor: isOver ? 'primary.main' : 'divider',
        borderRadius: 1,
        m: 0.5,
        bgcolor: isOver ? 'action.selected' : 'action.hover',
        transition: 'all 0.2s',
      }}
    >
      {children || (
        <Box
          component="span"
          onClick={() => onAdd?.(position)}
          sx={{
            cursor: 'pointer',
            color: isOver ? 'primary.main' : 'text.secondary',
            fontSize: '0.875rem',
            '&:hover': { color: 'primary.main' },
          }}
        >
          {label || `Drop or add panel (${position})`}
        </Box>
      )}
    </Box>
  );
}
